import { ClerkProvider, SignedIn, SignedOut } from "@clerk/clerk-react";
import { ScheduleForm } from "./ScheduleForm";
import { Navbar } from "./Navbar";
import { HomePage } from "./HomePage";
import { ScheduledList } from "./ScheduledList";
import { PricingPage } from "./PricingPage";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

const clerkPubKey = process.env.CLERK_PUBLISH_KEY; 

export function App() {
  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <Router>
        <Navbar />
        <div className="app">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/*" element={<HomePage />} />
            <Route path="/schedule" element={<ScheduleForm />} />
            <Route path="/scheduled" element={<ScheduledList />} />
            <Route path="/pricing" element={<PricingPage />} />
          </Routes>
        </div>
      </Router>
    </ClerkProvider>
  );
}

export default App;
